import $ from 'jquery'

const $doc = $(document)
const $mobileNav = $('.js-mobile-nav')
const $hamburger = $('.js-hamburger')

function setMobileNavOpen(isOpen) {
  $mobileNav.toggleClass('is-active', isOpen)
  $hamburger.toggleClass('is-active', isOpen)
  $hamburger.parent().toggleClass('is-active', isOpen)
  $hamburger.attr('aria-expanded', isOpen ? 'true' : 'false')
  $mobileNav.attr('aria-hidden', isOpen ? 'false' : 'true')
  if (isOpen) {
    $mobileNav.removeAttr('inert')
  } else {
    $mobileNav.attr('inert', '')
  }
}

function showMobileNav(event) {
  event.preventDefault()
  setMobileNavOpen(!$mobileNav.hasClass('is-active'))
}

export default function initMobileNav(){
  $doc.on('click', '.js-hamburger', showMobileNav )
  $doc.on('keydown', function(event) {
    if ( $mobileNav.hasClass('is-active') && (event.key == "Escape") ) {
      setMobileNavOpen(false)
    }
  })
  $doc.on('focusin', function (event) {
    var $target = $(event.target);
    if (!$target.closest('.js-header-wrapper').length) {
      if ( $mobileNav.hasClass('is-active') ) {
        setMobileNavOpen(false)
      }
    }
  })
}
